import { EventTypes } from '@racemap/sdk/schema/events';
import type { JSX } from 'react';
import { type StarterType, useStore } from 'src/lib/player/store';
import StarterListItem from './StarterListItem';

type Props = {
  starter: StarterType;
  starterOpacity: number;
  starterOffset: number;
  starterTimestamp: number;
  onClick?: (starter: StarterType, isSelected: boolean) => void;
};

export default function ConnectedStarterListItem({
  starter,
  starterOpacity,
  starterOffset,
  starterTimestamp,
  onClick,
}: Props): JSX.Element {
  const toggleHidden = useStore((state) => state.actions.toggleHidden);
  const setHighlighted = useStore((state) => state.actions.setHighlighted);
  const toggleSelectedStarter = useStore((state) => state.actions.toggleSelectedStarter);
  const isLive = useStore((state) => state.timer.isLive);
  const now = useStore((state) => state.timer.time);
  const isSelected = useStore((state) => state.timer.selected.includes(starter.id));
  const isHighlighted = useStore((state) => state.timer.highlighted === starter.id);
  const isVisible = useStore((state) => !state.timer.hidden.has(starter.id));
  const eventNames = useStore((state) =>
    state.currentEventIndices.length > 1 && state.options.type === EventTypes.CONTEST_GROUP
      ? (state.startersById
          ?.get(starter.id)
          ?.filter((s) => state.currentEventIndices.includes(s.eventIndex))
          .map((s) => state.events[s.eventIndex].shortName)
          .join(', ') ?? null)
      : null,
  );
  const unitType = useStore((state) => state.options.unitType);

  return (
    <StarterListItem
      starter={starter}
      starterOpacity={starterOpacity}
      starterOffset={starterOffset}
      starterTimestamp={starterTimestamp}
      isSelected={isSelected}
      isHighlighted={isHighlighted}
      isVisible={isVisible}
      isLive={isLive}
      now={now}
      eventNames={eventNames}
      unitType={unitType}
      onClick={onClick}
      onToggleSelected={() => toggleSelectedStarter(starter.id)}
      onToggleHidden={() => toggleHidden(starter.id)}
      onPointerEnter={() => setHighlighted(starter.id)}
      onPointerLeave={() => setHighlighted(null)}
    />
  );
}
